export const designationMapping = {
  "President": 0,
  "First Vice President": 1,
  "Vice President": 2,
  "General Secretary": 3,
  "Joint Secretary and Treasurer": 4,
  "Chairman Monitoring Committe": 5,
  "Secretary": 6,
  "Joint Secretary": 7,
};

export const departmentMapping = {
  "Jain Samaj": 0,
  "Treasurer": 1,
  "Advisor, Jain Bhawan Committe": 2,
  "Advisor, Mahavir Bhawan Committe": 3,
  "Advisor, Jain School Committe": 4,
  "Advisor, Construction Committe": 5,
  "Advisor, Jain College Committe": 6,
  "Advisor, Saint related matters Committe": 7,
  "Information & Publicity": 8,
  "Finance Secretary": 9,
  "Jain College": 10,
  "Jain School": 11,
  "Jain Bhawan": 12,
  "Jain Hospital": 13,
  "Mahavir Bhawan": 14,
  "Saints": 15,
  "Puchara Committe": 16,
  "Mahavir Sthal": 17,
  "Cultural department and Pathshala": 18,
  "Public Relations Officer": 19,
  "Executive member": 20,
};
